const TRANSACTION_TYPE_STORAGE_KEY = 'transactionType';
export const TRANSACTION_TYPE_WITHDRAWAL = 'withdrawal';
export const TRANSACTION_TYPE_DEPOSIT = 'deposit';

/* записываем в ls, что процесс вывода находится в состоянии inProgress */
export const setWithdrawalInProgress = () =>
  localStorage.setItem(TRANSACTION_TYPE_STORAGE_KEY, TRANSACTION_TYPE_WITHDRAWAL);
/* записываем в ls, процесс депозита находится в состоянии inProgress */
export const setDepositInProgress = () =>
  localStorage.setItem(TRANSACTION_TYPE_STORAGE_KEY, TRANSACTION_TYPE_DEPOSIT);
export const clearTransactionType = () => localStorage.removeItem(TRANSACTION_TYPE_STORAGE_KEY);
export const getTransactionType = () => localStorage.getItem(TRANSACTION_TYPE_STORAGE_KEY);
